import React, { Component } from "react";
import {
  Navbar,
  NavbarBrand,
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input
} from "reactstrap";
import Joi from "joi-browser";
import httpClient from "../http-client/client";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

class SignUpComplete extends Component {
  state = {
    provinces: [],
    cities: [],
    phoneNumber: "",
    stateId: "",
    cityId: "1",
    agentAddress: "",
    proprietorName: "",

    errors: {}
  };

  schema = Joi.object().keys({
    phoneNumber: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "Phone Number is Required"
        };
      }),
    cityId: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "Select City"
        };
      }),
    agentAddress: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "Address is Required"
        };
      }),
    proprietorName: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "Propritor Name is Required"
        };
      })
  });

  componentDidMount() {
    // Get Operators
    this.getState();
  }

  async getState() {
    try {
      let { data } = await httpClient.get("/states");
      this.setState({ provinces: data["response"] });
    } catch (error) {
      this.setState({ provinces: [] });
    }
  }

  async getCity(id) {
    try {
      let { data } = await httpClient.get(`/cities/${id}`);
      this.setState({ cities: data["response"] });
    } catch (error) {
      this.setState({ cities: [] });
    }
  }

  handleState = e => {
    let value = e.target.value;
    this.getCity(value);
    this.setState({ stateId: value, cityId: "" });
  };

  reset = () => {
    let errors = {};
    this.setState({
      phoneNumber: "",
      stateId: "",
      cityId: "",
      agentAddress: "",
      proprietorName: "",
      errors
    });
  };

  //change handler
  handleChange = event => {
    let value = event.target.value;
    this.setState({ [event.target.name]: value });
  };

  validation() {
    let { proprietorName, phoneNumber, cityId, agentAddress } = this.state;
    let { error } = Joi.validate(
      { proprietorName, phoneNumber, cityId, agentAddress },
      this.schema,
      {
        abortEarly: false
      }
    );

    // No error found
    if (!error) return null;

    let errors = {};
    error.details.map(err => 
      errors[err.path[0]] = err["message"]
    );

    return errors;
  }

  // Submit handler
  handleSubmit = async event => {
    event.preventDefault();

    // validation
    let errors = this.validation();
    if (errors) {
      this.setState({ errors });
      return;
    } else {
      this.setState({ errors: {} });
    }

    let { proprietorName, phoneNumber, agentAddress } = this.state;

    try {
      var { status } = await httpClient.put("/agent/signup_complete", {
        proprietorName,
        phoneNumber,
        cityId: 1,
        agentAddress
      });

      if (status === 200) {
        // move to dashboard
        this.props.history.push("/dashboard");
      }
    } catch (error) {
      // error occur

      toast.error("Oops something went wrong!!!", {
        position: toast.POSITION.BOTTOM_RIGHT,
        transition: Slide
      });
    }
  };

  render() {
    // check if verificationTokenIs one then redirect it to dashboard
    // if zero  then redirect it to login

    let {
      proprietorName,
      phoneNumber,
      cityId,
      agentAddress,
      errors,
      stateId,
      provinces,
      cities
    } = this.state;

    const provinceList = provinces.map(p => (
      <option key={p["state_id"]} value={p["state_id"]}>
        {p["state_name"]}
      </option>
    ));

    const cityList = cities.map(c => (
      <option key={c["city_id"]} value={c["city_id"]}>
        {c["city_name"]}
      </option>
    ));

    return (
      <div style={{ backgroundColor: "#f8f9fa" }}>
        {/* Top band */}
        <Navbar color="primary-theme" dark expand="md">
          <div className="container">
            <NavbarBrand href="/">
              <h2>Gmandi</h2>
            </NavbarBrand>
          </div>
        </Navbar>

        {/* end top band */}

        {/* Registration form */}
        <div className="container mt-3 ">
          <div className="row">
            <div className="col-sm-6 offset-sm-3">
              <h3 className="text-center">غلہ منڈی میں خوش آمدید</h3>
              <Form className="row">
                <FormGroup className="col-sm-12 col-md-12">
                  <Label for="bussinessName">مالک کا نام</Label>
                  <Input
                    value={proprietorName}
                    name="proprietorName"
                    placeholder="Proprietor Name"
                    invalid={Boolean(errors["proprietorName"])}
                    onChange={this.handleChange}
                  />
                  {errors["proprietorName"] && (
                    <FormFeedback>{errors["proprietorName"]}</FormFeedback>
                  )}
                </FormGroup>
                <FormGroup className="col-sm-12 col-md-12">
                  <Label for="bussinessName">فون نمبر</Label>
                  <Input
                    type="text"
                    value={phoneNumber}
                    name="phoneNumber"
                    placeholder="0333xxxxxxxx,0300xxxxxxxx,0344xxxxxxxxx"
                    invalid={Boolean(errors["phoneNumber"])}
                    onChange={this.handleChange}
                  />
                  {errors["phoneNumber"] && (
                    <FormFeedback>{errors["phoneNumber"]}</FormFeedback>
                  )}
                </FormGroup>

                <FormGroup className="col-sm-12">
                  <Label for="exampleSelect">صوبہ</Label>
                  <Input
                    type="select"
                    name="stateId"
                    value={stateId}
                    id="exampleSelect"
                    onChange={this.handleState}
                  >
                    <option value="">Select Province</option>
                    {provinceList}
                  </Input>
                </FormGroup>

                <FormGroup className="col-sm-12">
                  <Label for="exampleSelect">شہر</Label>
                  <Input
                    type="select"
                    name="cityId"
                    value={cityId}
                    id="exampleSelect"
                    invalid={Boolean(errors["cityId"])}
                    onChange={this.handleChange}
                  >
                    <option value="">Select City</option>
                    {cityList}
                  </Input>
                  {errors["cityId"] && (
                    <FormFeedback>{errors["cityId"]}</FormFeedback>
                  )}
                </FormGroup>

                <FormGroup className="col-sm-12">
                  <Label for="bussinessName">پتہ</Label>
                  <Input
                    value={agentAddress}
                    name="agentAddress"
                    placeholder="Address"
                    invalid={Boolean(errors["agentAddress"])}
                    onChange={this.handleChange}
                  />
                  {errors["agentAddress"] && (
                    <FormFeedback>{errors["agentAddress"]}</FormFeedback>
                  )}
                </FormGroup>
                <div className="col-sm-12 mb-5">
                  {/* <Button
                    color="danger mr-1"
                    onClick={() => {
                      this.props.history.push("/dashboard");
                    }}
                  >
                    Skip
                  </Button> */}
                  <Button color="success" onClick={this.handleSubmit}>
                    جمع کرائیں
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
        {/* End Registration form */}

        {/* toast notifiction */}
        <ToastContainer />
      </div>
    );
  }
}

export default SignUpComplete;
